import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";

function t(t, e) {
  var s, n, r, o;
  var u, c;
  if (b(t)) c = t;else if ('function' == typeof t) u = t;else {
    w('object' == typeof t && null !== t, 'shape should be store or object with stores');

    var _e = S(t);

    c = _e;
  }
  var i = null !== (s = null === (n = c) || void 0 === n ? void 0 : n.shortName) && void 0 !== s ? s : 'Unknown',
      a = g(i + ".View mounted"),
      p = g(i + ".View unmounted");
  return o = r =
  /*#__PURE__*/
  function (_l) {
    _inherits(r, _l);

    function r() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, r);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(r)).call.apply(_getPrototypeOf2, [this].concat(e))), _this._unsubscribe = null, _this._hasUnmounted = 0, _this.store = 'function' == typeof t ? u(_this.props) : c, _this.state = {
        currentState: _this.store.getState()
      };
      return _this;
    }

    _createClass(r, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        a({
          props: this.props,
          state: this.store.getState()
        }), this.subscribe();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        p({
          props: this.props,
          state: this.store.getState()
        }), this.unsubscribe(), this._hasUnmounted = 1;
      }
    }, {
      key: "render",
      value: function render() {
        return e(this.props, this.state.currentState);
      }
    }, {
      key: "subscribe",
      value: function subscribe() {
        var _this2 = this;

        this._unsubscribe = this.store.watch(function (t) {
          _this2._hasUnmounted || _this2.setState(function (e) {
            return t === e.currentState ? null : {
              currentState: t
            };
          });
        });
      }
    }, {
      key: "unsubscribe",
      value: function unsubscribe() {
        'function' == typeof this._unsubscribe && this._unsubscribe(), this._unsubscribe = null;
      }
    }]);

    return r;
  }(l), r.displayName = i + ".View", r.mounted = a, r.unmounted = p, o;
}

function e(e) {
  return t(e, function (_ref, e) {
    var t = _ref.children;
    return t(e);
  });
}

function s(t) {
  var e, s;
  return s = e =
  /*#__PURE__*/
  function (_l2) {
    _inherits(e, _l2);

    function e() {
      var _getPrototypeOf3;

      var _this3;

      _classCallCheck(this, e);

      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }

      _this3 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(e)).call.apply(_getPrototypeOf3, [this].concat(t))), _this3.state = {
        currentValue: null
      };
      return _this3;
    }

    _createClass(e, [{
      key: "render",
      value: function render() {
        return this.props.children;
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(e) {
        return t.setState(e.value), {
          currentValue: e.value
        };
      }
    }]);

    return e;
  }(l), e.displayName = t.shortName + ".Provider", e.defaultProps = {
    children: null
  }, s;
}

function n(t, s, n) {
  var r, o;
  var u = e(t);
  return o = r =
  /*#__PURE__*/
  function (_l3) {
    _inherits(r, _l3);

    function r() {
      var _getPrototypeOf4;

      var _this4;

      _classCallCheck(this, r);

      for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        t[_key3] = arguments[_key3];
      }

      _this4 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(r)).call.apply(_getPrototypeOf4, [this].concat(t))), _this4.renderProp = function (t) {
        return n(_this4.props, t, _this4.context);
      };
      return _this4;
    }

    _createClass(r, [{
      key: "render",
      value: function render() {
        return p(u, null, this.renderProp);
      }
    }]);

    return r;
  }(l), r.contextType = s, o;
}

function r(t) {
  w(v.store(t), 'useStore: The argument must be Store, but you passed %s', t);
  var e = h(x, void 0, t.getState)[1];
  return N(function () {
    return t.watch(e);
  }, [t]), t.getState();
}

function o() {
  return (o = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var s = arguments[e];

      for (var n in s) {
        ({}).hasOwnProperty.call(s, n) && (t[n] = s[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function u(t, s) {
  var n = e(t),
      r = function r(t) {
    return p(n, null, function (e) {
      return p(s, o({}, t, e));
    });
  };

  return r.displayName = "Connect(" + (s.displayName || s.name || 'Unknown') + ")", r;
}

function c(t) {
  return function (e) {
    return u(e, t);
  };
}

function i(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  f(function () {
    return t.open(), function () {
      return t.close();
    };
  }, [t]), t.set(e);
}

function a() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "gate";
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var s = U(0),
      n = U(e),
      _ref2 = _(n, {
    set: function set(t, e) {
      return e;
    }
  }),
      r = _ref2.set,
      _ref3 = _(s, {
    open: function open() {
      return i.predicate() && 1;
    },
    close: function close() {
      return 0;
    },
    destructor: function destructor() {
      return 0;
    }
  }),
      o = _ref3.open,
      u = _ref3.close,
      c = _ref3.destructor;

  var i =
  /*#__PURE__*/
  function (_m) {
    _inherits(i, _m);

    function i() {
      _classCallCheck(this, i);

      return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
    }

    _createClass(i, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        i.open();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        i.close();
      }
    }, {
      key: "render",
      value: function render() {
        return i.set(this.props), null;
      }
    }], [{
      key: "childGate",
      value: function childGate() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Subgate";
        var s = a(t + "/" + e);

        s.predicate = function () {
          return i.status.getState();
        };

        var n = 0,
            r = 0;
        return s.open.watch(function () {
          r || (n = 1);
        }), s.close.watch(function () {
          r || (n = 0);
        }), i.status.watch(function (t) {
          r = 1, n && t && !s.status.getState() && s.open(), r = 0;
        }), i.close.watch(function () {
          r = 1, s.close(), r = 0;
        }), i.destructor.watch(function () {
          return s.destructor();
        }), s;
      }
    }]);

    return i;
  }(m);

  i.predicate = function () {
    return 1;
  }, i.displayName = "Gate:" + t, i.isOpen = 0, i.current = n.getState(), i.open = o, i.close = u, i.status = s, i.state = n, i.set = r, i.destructor = c, i.isTerminated = 0;
  var l = s.watch(function (t) {
    return i.isOpen = t;
  }),
      p = n.watch(function (t) {
    return i.current = t;
  });
  s.map(function (t) {
    t || (i.current = e);
  }), n.reset(u);
  var h = c.watch(function () {
    i.isTerminated = 1;
  }),
      d = c.watch(function () {
    d(), l(), p(), h(), i.status.off(i.open), i.status.off(i.close), i.status.off(i.destructor), i.state.off(i.set);
  });
  return i;
}

import { Component as l, createElement as p, useReducer as h, useLayoutEffect as d, useEffect as f, PureComponent as m } from 'react';
import { isStore as b, invariant as w, createStoreObject as S, createEvent as g, is as v, createDomain as y, createApi as _ } from 'effector';

var x = function x(t, e) {
  return e;
},
    N = 'undefined' != typeof window ? d : f,
    _y = y('Gate'),
    U = _y.store;

export { c as connect, t as createComponent, n as createContextComponent, a as createGate, u as createReactState, e as createStoreConsumer, s as unstable_createStoreProvider, i as useGate, r as useStore };